import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const HeaderNavigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    {
      label: 'Generate',
      path: '/prompt-input',
      icon: 'Plus',
      tooltip: 'Create new project'
    },
    {
      label: 'My Projects',
      path: '/project-dashboard',
      icon: 'Folder',
      tooltip: 'View project history'
    },
    {
      label: 'Account',
      path: '/authentication',
      icon: 'User',
      tooltip: 'Manage account settings'
    }
  ];

  const isActivePath = (path) => {
    if (path === '/prompt-input') {
      return ['/prompt-input', '/code-generation', '/file-explorer', '/download-modal']?.includes(location?.pathname);
    }
    return location?.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header className="header-nav">
        <div className="header-nav-container">
          <Link to="/landing-page" className="header-logo">
            <div className="header-logo-icon">
              <Icon name="Code2" size={24} color="#FFFFFF" />
            </div>
            <span className="header-logo-text">Giati Builder</span>
          </Link>

          <nav className="header-nav-menu">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`header-nav-item ${isActivePath(item?.path) ? 'active' : ''}`}
                title={item?.tooltip}
              >
                <Icon name={item?.icon} size={18} />
                <span>{item?.label}</span>
              </Link>
            ))}
          </nav>

          <div className="header-nav-actions">
            <Button
              variant="outline"
              size="sm"
              iconName="HelpCircle"
              iconPosition="left"
              className="hidden lg:flex"
            >
              Help
            </Button>
          </div>

          <button
            onClick={toggleMobileMenu}
            className="header-mobile-toggle"
            aria-label="Toggle mobile menu"
            aria-expanded={isMobileMenuOpen}
          >
            <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
          </button>
        </div>
      </header>
      {isMobileMenuOpen && (
        <div className="header-mobile-menu animate-fade-in">
          <div className="header-mobile-menu-content">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`header-nav-item ${isActivePath(item?.path) ? 'active' : ''}`}
                onClick={closeMobileMenu}
              >
                <Icon name={item?.icon} size={20} />
                <span>{item?.label}</span>
              </Link>
            ))}
            <div className="mt-4 pt-4 border-t border-border">
              <Button
                variant="outline"
                fullWidth
                iconName="HelpCircle"
                iconPosition="left"
              >
                Help & Support
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HeaderNavigation;